import React, { JSX, useContext, useEffect } from 'react';
import Layout from '../components/Layout';
import MaintenanceSchedules from '../components/MaintenanceSchedules';
import StatusDashboard from '../components/StatusDashboard';
import { PAGE_TITLE_SUFFIX } from '../constants';
import { BreadcrumbType, Store } from '../store';

const Top: React.FC = (): JSX.Element => {
  const { setGlobalState } = useContext(Store);

  // biome-ignore lint/correctness/useExhaustiveDependencies: マウント時に1度だけ実行
  useEffect(() => {
    const breadcrumbs: BreadcrumbType[] = [{ text: 'メンテナンス・障害情報', path: '/' }];
    setGlobalState({ type: 'SET_BREADCRUMBS', payload: breadcrumbs });

    document.title = `${breadcrumbs.slice(-1)[0].text} ${PAGE_TITLE_SUFFIX}`;

    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <StatusDashboard />
      <MaintenanceSchedules />
    </Layout>
  );
};

export default Top;
